import Balance, { Provider as BalanceProvider } from "react-wrap-balancer";

import cx from "@hsl/core/utils/cx";

import useTranslation, { Translate } from "../../../hooks/useTranslation";
import { txStrReplacer as replacer } from "../lib";

interface Props {
    className?: string;
}

export const EmptyState = ({ className }: Props) => {
    const tx = useTranslation();
    const subscribeTxt = tx(
        "Subscribe to funds by clicking on the bell [^] icons to receive emails when fact sheets and other fund literature is published or updated",
    ).result;
    const watchTxt = tx(
        "Create your own watchlist of funds by clicking on the star [*] icons",
    ).result;
    const iconClasses = "inline h-4 w-4 align-sub";
    return (
        <BalanceProvider>
            <div
                className={cx(
                    "border-platinum col-span-full flex flex-1 flex-col items-center border px-4 py-24 text-center",
                    className,
                )}
            >
                <div className="max-w-lg">
                    <h2 className="my-2 text-lg font-medium">
                        <Translate>No funds added yet</Translate>
                    </h2>
                    <Balance as="p" className="my-2">
                        {replacer(subscribeTxt, { iconClasses })}.
                    </Balance>
                    <Balance as="p" className="my-2">
                        {replacer(watchTxt, { iconClasses })}.
                    </Balance>
                </div>
            </div>
        </BalanceProvider>
    );
};
